import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[ridangoUntouchOnFocusout]',
})
export class UntouchOnFocusoutDirective {
    constructor(private ngControl: NgControl) {}

    @HostListener('focusout')
    clearEmptyError(): void {
        if (!this.ngControl.control.value) {
            this.ngControl.control.markAsUntouched();
        }
    }
}
